<template>
  <div>
    <b-row>
      <b-colxx xxs="12">
        <piaf-breadcrumb :heading="$t('menu.booking-unvisited')"/>
        <div class="separator mb-5"></div>
      </b-colxx>
    </b-row>

    <b-row>
      <b-colxx xxs="12">
        <b-card class="mb-4" title="예약조회">
          <b-row class="justify-content-start mb-5">
            <b-col align="center">
              <b-input-group class="ml-5 mr-3">
                <template v-slot:prepend>
                  <b-button @click="onClickPrev()" variant="outline-primary">◀</b-button>
                </template>
                <v-date-picker
                  mode="single"
                  v-model="searchDate"
                  :input-props="{ class:'form-control', placeholder: '' }"
                >
                </v-date-picker>
                <template v-slot:append>
                  <b-input-group-text>
                    <b-icon icon="calendar"></b-icon>
                  </b-input-group-text>
                  <b-button @click="onClickNext()" variant="outline-primary">▶</b-button>
                </template>
              </b-input-group>
            </b-col>
          </b-row>

          <b-row align-v="center" class="justify-content-start mb-1" no-gutters>
            <b-col cols="6">
              <b-input-group class="mb-3">
                <v-select :options="searchOptions" v-model="searchKind" style="width:300px"></v-select>
                <b-input :placeholder="$t('menu.search')" v-model="searchKeyword" style="width:500px" class="ml-2"/>
                <b-button v-show="!searchFlag" @click="onSearch" variant="outline-primary default" size="sm">
                  {{$t('button.search')}}
                </b-button>
                <b-button v-show="searchFlag" @click="searchCancel" variant="outline-primary" size="sm">
                  {{$t('button.search-cancel')}}
                </b-button>
              </b-input-group>
            </b-col>
          </b-row>

          <template v-if="isLoad">
            <booking-list
              :items="items"
              :fields = "fields"
              :per-page="perPage"
              :currentPage="currentPage"
              @click-row="onClickRow"
              @confirm-proc=""
              @deny-proc=""
            />

            <b-pagination v-if="lastPage > 1"
                          size="sm"
                          align="center"
                          :total-rows="total"
                          :per-page="perPage"
                          v-model="currentPage"
            >
              <template v-slot:next-text>
                <i class="simple-icon-arrow-right"/>
              </template>
              <template v-slot:prev-text>
                <i class="simple-icon-arrow-left"/>
              </template>
              <template v-slot:first-text>
                <i class="simple-icon-control-start"/>
              </template>
              <template v-slot:last-text>
                <i class="simple-icon-control-end"/>
              </template>
            </b-pagination>
          </template>

          <template v-else>
            <div class="loading"></div>
          </template>
          <template>
            <b-row align-v="center" align-h="center" class="mt-0" no-gutters>
              <b-modal id="bookingdetails" ref="bookingdetails" size="lg" title="예약 상태" :hide-backdrop="false"
                       :no-close-on-backdrop="true">
                <booking-visit-detail v-bind:data="bookingInfo" :modifyFlag="true"/>
                <template slot="modal-footer">
                  <b-button variant="outline-primary" @click="hideModal()">취소</b-button>
                  <b-button variant="success" @click="saveInfo()">예약내용변경</b-button>
                  <b-button variant="primary" @click="setVisited()" class="mr-1">방문완료처리</b-button>
                </template>
              </b-modal>
            </b-row>
          </template>
        </b-card>
      </b-colxx>
    </b-row>
  </div>

</template>

<script>
  import vSelect from 'vue-select'
  import 'vue-select/dist/vue-select.css'
  import api from '../../constants/api'
  import BookingVisitDetail from './components/BookingDetailView'
  import BookingList from "./components/BookingList";

  import {
    mapGetters,
    mapActions,
    mapMutations
  } from "vuex";
  import {alignTableCenter} from "../../utils";

  export default {
    components: {
      'v-select': vSelect,
      'booking-visit-detail' : BookingVisitDetail ,
      'booking-list' : BookingList
    },
    data() {
      return {
        transProps: {
          // Transition name
          name: 'list'
        },
        searchKind: {label: '예약번호', value: 'bookingId'},
        searchOptions: [
          {label: '예약번호', value: 'bookingId'},
          {label: '전화번호', value: 'phone'},
        ],
        searchDate: this.$route.query.searchDate ? this.$moment(this.$route.query.searchDate).toDate() : new Date(),
        isLoad: false,
        searchFlag: false,
        currentPage: 1,
        perPage: 30,
        lastPage: 0,
        total: 0,
        searchKeyword: "",
        items: [],
        fields: [
          {key: 'bookingId', label: "예약번호" , ...alignTableCenter},
          {key: 'store', label: "매장명" , ...alignTableCenter},
          {key: 'user', label: "예약자" , ...alignTableCenter},
          {key: 'phone', label: "전화번호" , ...alignTableCenter},
          {key: 'headcount', label: "인원" , ...alignTableCenter},
          {key: 'visitingDate', label: "방문예정일" , ...alignTableCenter},
          {key: 'bookingStatus', label: "예약상태" , ...alignTableCenter},
          {key: 'channel', label: "예약경로" , ...alignTableCenter},
        ],
        bookingInfo: null
      }
    },
    mounted() {
      this.searchData()
    },
    computed: {
      ...mapGetters(['currentUser', 'siteName'])
    },
    watch: {
      currentPage() {
        this.searchData()
      }
    },
    methods: {
      showModal() {
        this.$refs['bookingdetails'].show();
      },
      hideModal() {
        this.$refs['bookingdetails'].hide();
      },
      onClickPrev() {
        this.searchDate = this.$moment(this.searchDate).subtract(1, 'day').toDate()
        this.searchData()
      },
      onClickNext() {
        this.searchDate = this.$moment(this.searchDate).add(1, 'day').toDate()
        this.searchData()
      },
      onSearch() {
        if (this.searchKeyword === "") {
          alert('검색어를 입력하세요');
          return false
        }
        this.currentPage = 1
        this.searchFlag = true
        this.searchData()
      },
      searchCancel() {
        this.searchFlag = false;
        this.searchKeyword = ''
        this.searchData()
      },
      searchData() {
        this.isLoad = true
        const reqURL = api.changeAPI(this.siteName, api.basicURL + api.auth.login)
        const params = {}

        this.$http.get(reqURL, {
          params: params,
          headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}
        }).then(res => {
          if (res.data.code === "OK") {

          } else {
            throw 400
          }
        }).catch(err => {

        })

        this.items = [{
          id: 1,
          bookingId: "20200898761",
          store: "구로점",
          goods: "발렌타이데이 평일 점심 특가",
          user: "홍길동",
          phone: "010-0000-0000",
          headcount: 4,
          bookingDate: "20200101",
          visitingDate: "20200214",
          bookingStatus: "예약대기",
          channel: "자사 사이트",
          selected: false
        },
          {
            id: 2,
            bookingId: "20200828723",
            store: "구로점",
            goods: "발렌타이데이 평일 점심 특가",
            user: "카피추",
            phone: "010-0000-0000",
            headcount: 8,
            bookingDate: "20200131",
            visitingDate: "20200214",
            bookingStatus: "예약대기",
            channel: "테이블엔조이",
            selected: false
          },
          {
            id: 3,
            bookingId: "20200823427",
            store: "강남점",
            goods: "주말 석식 성인 4인권",
            user: "강아지",
            phone: "010-0000-0000",
            headcount: 4,
            bookingDate: "20200101",
            visitingDate: "20200214",
            bookingStatus: "예약대기",
            channel: "외부 채널",
            selected: false
          }]


      },
      onClickRow() {
        const reqURL = api.changeAPI(this.siteName, api.basicURL + api.auth.login)
        const params = {}

        //예약정보 불러오기 필요.
        this.$http.get(reqURL, {
          params: params,
          headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}
        }).then(res => {
          if (res.data.code === "OK") {

          } else {
            throw 400
          }
        }).catch(err => {

        })

        this.bookingInfo = {
          bookingId: "202023423423",
          user: "카피츄",
          phone: "010-0000-0000",
          headcount: {
            adult: 3,
            child: 1
          },
          goodsName: "발렌타인데이 주말 점심특가",
          request: '아기의자',
          store: "강남점",
          bookingDate: "2020-01-13 13:45:00",
          visitingDate: "2020-12-04 17:30:00",
          bookingStatus: "예약완료",
          channel: "위메프",
          purchaseList: [
            {coupon: "20202342934", goods: "성인 1인권", unused: false},
            {coupon: "20202323442", goods: "성인 1인권", unused: false},
            {coupon: "20202323423", goods: "어린이 1인권", unused: false}
          ],
        }

        this.showModal();
      },
      saveInfo(){ //예약정보 수정 처리

        if ( this.bookingInfo.user === null ) {
          alert('예약자명을 입력해주세요')
          return false
        } else if (this.bookingInfo.phone === null ){
          alert('예약자명을 입력해주세요')
          return false
        } else if( this.bookingInfo.headcount.adult === null ){
          alert('예약자명을 입력해주세요')
          return false
        } else {

          if( confirm( '예약내용을 변경하시겠습니까?') ){

            //예약상태 수정
            const reqURL = api.changeAPI(this.siteName, api.basicURL + api.auth.login)
            const params = {

            }

            this.$http.post(reqURL, params,{
              headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}
            }).then(res => {
              if ( res.data.code === "OK" ) {

              } else {
                throw 400
              }
            }).catch(err => {

            })

          }

        }


      },
      setVisited() { //예약방문처리
        let errFlag = true
        this.bookingInfo.purchaseList.forEach(function(value){
          if( value.unused ){
            errFlag = false
            return false
          }
        })

        if( errFlag ){
          alert('방문완료 처리 할 쿠폰을 선택해주세요.')
          return false
        }
        if (confirm('방문완료 처리 하시겠습니까?')) {
          //방문완료 처리 필요
          const reqURL = api.changeAPI(this.siteName, api.basicURL + api.auth.login)
          const params = {

          }

          this.$http.post(reqURL, params,{
            headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}
          }).then(res => {
            if ( res.data.code === "OK" ) {

            } else {
              throw 400
            }
          }).catch(err => {

          })

          this.hideModal()
        }
      }
    }
  }
</script>

